<template>
  <main>
    <section class="search container c2f_top_section">
      <div class="row">
        <div class="col-12">
          <h3 class="text-green">新增家戶成員</h3>
          <div class="label c2f_top_text">
            請輸入您想加入
            <span
              v-show="headFamily.name && headFamily.name.length > 6"
              class="text-green"
            >
              <a
                class="link text-underline all-name"
                tabindex="0"
                data-toggle="popover"
                id="user-name"
                role="button"
                :data-content="headFamily.name"
              >
                {{ headFamily.name.substring(0, 6) + "..." }}
              </a>
            </span>
            <span
              v-show="!(headFamily.name && headFamily.name.length > 6)"
              class="text-green"
            >
              {{ headFamily.name }}
            </span>
            的家戶的成員資訊
          </div>
        </div>
      </div>
    </section>
    <!-- input section -->
    <section class="search container card" style="margin-bottom: 130px">
      <div class="row card-list-wrapper">
        <div
          v-for="(form, id) in forms"
          :key="`cust-form-${id}`"
          class="col-md-12"
        >
          <form class="form bgColor">
            <section class="card">
              <div class="row">
                <div
                  class="
                    col-1
                    d-flex
                    align-items-center
                    justify-content-center
                    card-number
                  "
                  style="max-width: 5%"
                >
                  {{ id + 1 }}
                </div>
                <div class="col-11 pl-3">
                  <a
                    v-if="id > 0"
                    @click="handleRemove(id)"
                    class="btn btn-default delete-btn"
                    >刪除</a
                  >
                  <div class="form-group row">
                    <div class="col-4 d-flex flex-column">
                      <label class="mb-2" for="client-name">
                        姓名
                        <span class="waring-block d-inline-block ml-2">
                          <span class="text">必填</span>
                        </span>
                      </label>
                      <div class="input">
                        <input
                          maxlength="50"
                          type="text"
                          id="`name-${id}`"
                          :data-vv-name="`name-${id}`"
                          v-model="form.name"
                          placeholder="姓名"
                          data-vv-as="姓名"
                          :class="{ 'is-invalid': errors.has(`name-${id}`) }"
                          v-validate="'required|checkNm'"
                          class="form-control"
                          alt="ch"
                          @input="checkInputName(form)"
                          @blur="checkInputName(form)"
                        />
                        <span
                          class="clearPosition"
                          v-if="errors.has(`name-${id}`)"
                          @click="doClean(1, form, `name-${id}`)"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                      </div>
                      <span class="waring-text">
                        {{ errors.first(`name-${id}`) }}
                      </span>
                    </div>
                    <div class="col-3 d-flex flex-column">
                      <label class="mb-2" for="client-personalid">
                        身分證
                        <span class="waring-block d-inline-block ml-2">
                          <span class="text">必填</span>
                        </span>
                      </label>
                      <div class="input">
                        <input
                          type="text"
                          id="client-personalid"
                          maxlength="10"
                          :data-vv-name="`personalid-${id}`"
                          v-model="forms[id].personalid"
                          placeholder="身分證字號"
                          :class="{
                            'is-invalid': errors.has(`personalid-${id}`),
                          }"
                          v-validate="'required'"
                          class="form-control"
                          data-vv-as="身分證字號"
                          @input="inputId(form, id)"
                          @blur="inputId(form, id)"
                        />
                        <span
                          class="clearPosition"
                          v-if="errors.has(`personalid-${id}`)"
                          @click="doClean(2, form, `personalid-${id}`)"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                      </div>
                      <span class="waring-text">
                        {{ errors.first(`personalid-${id}`) }}
                      </span>
                    </div>
                    <div class="col-3 d-flex flex-column">
                      <label class="mb-2">
                        性別
                        <span class="waring-block d-inline-block ml-2">
                          <span class="text">必填</span>
                        </span>
                      </label>
                      <div class="d-flex">
                        <div class="radio radio-inline">
                          <input
                            type="radio"
                            value="1"
                            v-model="form.sex"
                            :id="`1sex-${id}`"
                            v-validate="'required'"
                            :data-vv-name="`sex-${id}`"
                            data-vv-as="性別"
                            :name="`sex-${id}`"
                          />
                          <label :for="`1sex-${id}`">男</label>
                        </div>
                        <div class="radio radio-inline">
                          <input
                            type="radio"
                            value="2"
                            :id="`0sex-${id}`"
                            v-model="form.sex"
                            :data-vv-name="`sex-${id}`"
                            data-vv-as="性別"
                            :name="`sex-${id}`"
                          />
                          <label :for="`0sex-${id}`">女</label>
                        </div>
                      </div>
                      <span class="waring-text">
                        {{ errors.first(`sex-${id}`) }}
                      </span>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-3 d-flex flex-column">
                      <label class="mb-2" for="client-role">
                        身份
                        <span class="waring-block d-inline-block ml-2">
                          <span class="text">必填</span>
                        </span>
                      </label>

                      <select
                        class="form-control"
                        style="width: 66%"
                        id="client-role"
                        :data-vv-name="`role-${id}`"
                        :class="{ 'is-invalid': errors.has(`role-${id}`) || isRelationError[id] }"
                        v-validate="`required|checkHasSpouse:${hasSpouse}`"
                        data-vv-as="身份"
                        v-model="form.relation"
                      >
                        <option value>請選擇</option>
                        <option
                          v-for="(type, index) in familyRl"
                          :value="type.role_id"
                          :key="index"
                        >
                          {{ type.role_name }}
                        </option>
                      </select>
                      <span class="waring-text">
                        {{ errors.first(`role-${id}`) }}
                      </span>
                    </div>

                    <div class="col-4 d-flex flex-column">
                      <label for="client-name" class="mb-2 d-flex">
                        生日
                        <span class="waring-block d-inline-block ml-2">
                          <span class="text lg">生日或年齡擇一填寫</span>
                        </span>
                      </label>
                      <div class="form-group">
                        <BirthdayComponent
                          :validateOpen=" (!form.age || String(form.age).trim() === '') && form.age !== 0"
                          :isBirdayError="isBirdayError[id] ? isBirdayError[id] : false"
                          ref="birthday"
                          @getTime="getTime($event, form, id, `age-${id}`)"
                        />
                      </div>
                    </div>

                    <div class="col-2 d-flex flex-column">
                      <label class="mb-2" for="client-age">年齡</label>
                      <div class="input">
                        <input
                          type="text"
                          maxlength="3"
                          pattern="\d*"
                          id="client-age"
                          :data-vv-name="`age-${id}`"
                          placeholder="年齡"
                          v-model="form.age"
                          :class="{ 'is-invalid': errors.has(`age-${id}`) }"
                          data-vv-as="生日或年齡"
                          v-validate="{
                            required: forms[id].birthday == '',
                            numeric: forms[id].birthday == '',
                          }"
                          class="form-control"
                          ref="age"
                          @click="resetBirthdayComponent(id)"
                          @input="checkInputAge(form)"
                          @blur="checkInputAge(form)"
                        />
                        <span
                          class="clearPosition"
                          v-if="errors.has(`age-${id}`)"
                          @click="doClean(3, form, `age-${id}`)"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                      </div>
                      <span class="waring-text">
                        {{ errors.first(`age-${id}`) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </form>
        </div>
        <div class="col-md-12">
          <div
            @click="handleAddData()"
            class="
              card
              add
              d-flex
              align-items-center
              justify-content-center
              bgColor
            "
            style="cursor: pointer"
          >
            <i class="icon-add_new text-orange i-32"></i>
            <p>再增加一筆</p>
          </div>
        </div>
        <div class="col-md-12" style="height: 150px" v-show="isOpen"></div>
      </div>
    </section>
    <Fixed-Botton ref="fixedBtn">
      <template slot="@function">
        <button
          type="button"
          class="btn btn-default editbtn btnfont mr-3"
          @click="headFamily.name ? goBack('bkRelation') : goBack('bkmv-allHolder')"
        >
          取消
        </button>
        <button
          type="button"
          class="btn btn-primary editbtn btnfont"
          @click="handleNew()"
        >
          加入
        </button>
      </template>
    </Fixed-Botton >

    <!-- 打開遮罩 -->
    <Mv-Mask :open="mvMaskOpen" :content="maskContent" />
  </main>
</template>

<script>
import { Validator } from "vee-validate";
import FixedBotton from "@/desktop/components/fixedBotton";
import { zh } from "@/components/DatePicker/locale";
import { computeAge, insertCustInFamilyBnk } from "@/service";
import { getFamilyrl } from "@/service/modules/mvCommon";
import BirthdayComponent from "@/desktop/components/form/BirthdayComponent";
import { commonMixin } from "@/mixins/common";
import MvMask from "@/desktop/views/mv/components/mvMask";
import { mapActions } from "vuex";

Validator.extend("checkNm", {
  getMessage: "姓名不能有特殊符號",
  validate: (value) => {
    let pattern = /[<>!@#$^&,."'?%*()+/{}[\]|~`=\s]/g;
    let isNonEmpty = value.trim().length > 0;
    let isFormatCurrect = value.match(pattern) == null;
    return isNonEmpty && isFormatCurrect;
  },
});

Validator.extend("checkHasSpouse", {
  getMessage: "已存在配偶，無法再新增配偶",
  validate: (value, arg) => {
    if (value == 1 && arg[0] == "true") {
      return false;
    }
    return true;
  },
});

export default {
  name: "createBKCust2Family",
  mixins: [commonMixin],
  components: { FixedBotton, BirthdayComponent, MvMask },
  data() {
    return {
      headFamily: { name: "" }, //戶長資訊
      familyResult: [], //前一頁家戶資訊
      hasSpouse: false, //前一頁是否有配偶
      ajaxLoading: false, // 避免重複查詢
      dateFormatter: (date) => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        const y = date.getFullYear();
        if (y < 1911) {
          return `${y}/${(m < 10 ? "0" : "") + m}/${(d < 10 ? "0" : "") + d}`;
        }
        return `${y - 1911}/${(m < 10 ? "0" : "") + m}/${(d < 10 ? "0" : "") +
          d}`;
      },
      dateLang: zh,
      forms: [
        {
          name: "",
          personalid: "",
          birthday: "",
          sex: "",
          relation: "",
          birthYear: "",
          birthMonth: "",
          birthDate: "",
          age: "",
          birthDateOpt: [],
        },
      ],
      familyRl: [],
      isBirdayError: [],
      isRelationError: [],
      isOpen: false,
      mvMaskOpen: false, //遮罩
      maskContent: "資料更新中，請稍候...", //遮罩字樣
      //暫存個資法同意時間
      pdpaAgreeTime: "",
    };
  },
  created() {
    this.familyResult = this.$route.params.familyResult || [];
    this.hasSpouse = this.$route.params.hasSpouse || false;
    this.pdpaAgreeTime = this.$route.params.pdpaAgreeTime || "";
    this.registerHanlink();
  },
  mounted() {
    //取得下拉選單
    this.familyRl = getFamilyrl();
    // 取得戶長資訊
    if (this.familyResult.length > 0) {
      this.getHeadFamily();
      //除戶長欄位外皆要顯示
      this.familyRl = this.familyRl.filter((item, index) => index > 0);
    } else {
      this.forms[0].relation = "0";
    }
  },
  methods: {
    ...mapActions(["updateUserItems"]),
    //檢查姓名
    checkInputName(form) {
      form.name = form.name.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(form.name, false, 50) > 50) {
        form.name = form.name.substring(
          0,
          this.stringBytes(form.name, true, 50)
        );
      }
    },
    //檢查年齡
    checkInputAge(form) {
      form.age = form.age.replace(
        /[a-zA-Z<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(form.age, false, 3) > 3) {
        form.age = form.age.substring(0, this.stringBytes(form.age, true, 3));
      }
    },
    //判斷日曆下拉選單點選是否要增加顯示長度與滾動位移
    show(emitEvent, id) {
      if (id == this.forms.length - 1) {
        this.isOpen = !emitEvent;
        this.$nextTick(() => {
          document.documentElement.scrollTop =
            document.documentElement.scrollHeight;
        });
      }
    },
    inputId(form, id) {
      form.personalid = form.personalid.replace(
        /[^a-zA-Z0-9]/g,
        ""
      );
      this.selectSex(id);
    },
    //輸入身分證後選擇性別
    selectSex(id) {
      if (this.forms[id].personalid.length > 1) {
        var sexOfId = this.forms[id].personalid.substr(1, 1);
        if (sexOfId.toUpperCase().match("1|8|A|C")) {
          this.forms[id].sex = "1";
        } else if (sexOfId.toUpperCase().match("2|9|B|D")) {
          this.forms[id].sex = "2";
        }

        let name = this.forms[id].personalid.toUpperCase();
        this.forms[id].personalid = name;
      }
    },
    //BirthdayComponents 返回
    getTime(event, form, index, ageField) {
      form.ROCbirthday = event.date;
      form.age = event.age;
      if (form.ROCbirthday) {
        this.$refs.age[index].disabled = true;
        this.errors.remove(ageField);
      } else {
        this.$refs.age[index].disabled = false;
      }
    },
    resetBirthdayComponent(index) {
      this.$refs.birthday[index].reset();
    },
    //檢核
    handleNew() {
      let _this = this;
      async function asyncStart() {
        let check = true;
        // 檢核家戶既有人數+新增客戶的人數 不得超過50人+
        let familyResultCount = _this.familyResult
          ? _this.familyResult.length
          : 0;
        let formsCount = _this.forms ? _this.forms.length : 0;
        let checkCount = familyResultCount + formsCount;
        if (checkCount > 50) {
          _this.$toast.info({ title: "家戶成員不得超過50人+" });
          return;
        }

        await Promise.all(
          _this.$refs.birthday.map(
            async (e) =>
              (await e.validateAll()) === false ? (check = false) : ""
          )
        );
        //檢核生日
        let birthdayErrorCount = 0;
        _this.isBirdayError = [];
        _this.forms.map((item) => {
          if (
            item.ROCbirthday &&
            !window
              .moment(item.ROCbirthday)
              .isSameOrBefore(window.moment(), "day")
          ) {
            _this.isBirdayError.push(true);
            birthdayErrorCount++;
          } else {
            _this.isBirdayError.push(false);
          }
        });
        if (birthdayErrorCount > 0) {
          _this.$toast.info({ title: "出生日期不得超過今日" });
          return false;
        }

        _this.$validator.validateAll().then((el) => {
          if (!el || !check) {
            const errMsg =
              _this.errors.items.length > 1
                ? "尚有必填欄位待確認"
                : _this.errors.items[0].msg;
            _this.$toast.info({ title: errMsg });
            return;
          }

          //戶長、配偶計算
          let spouseCnt = 0;
          let houseHolderCnt = 0;
          _this.isRelationError = [];
          _this.forms.forEach(function(entry) {
            if (entry.relation == 0) {
              houseHolderCnt++;
            } else if (entry.relation == 1) {
              spouseCnt++;
            }
          });

          //戶長、配偶不能超過1個
          if (houseHolderCnt > 1 && _this.familyResult.length === 0) {
            _this.$toast.info({ title: "戶長不能超過1個" });
            _this.forms.forEach(function(entry) {
              if (entry.relation == 0) {
                _this.isRelationError.push(true);
              } else {
                _this.isRelationError.push(false);
              }
            });
            return;
          } else if (houseHolderCnt === 0 && _this.familyResult.length === 0) {
            _this.$toast.info({ title: "至少需有一位戶長" });
            _this.isRelationError = true;
            return;
          }
          if (spouseCnt > 1) {
            _this.$toast.info({ title: "配偶不能超過1個" });
            _this.forms.forEach(function(entry) {
              if (entry.relation == 1) {
                _this.isRelationError.push(true);
              } else {
                _this.isRelationError.push(false);
              }
            });
            return;
          }
          _this.submit();
          _this.$validator.reset();
        });
      }
      asyncStart();
    },
    //送出
    submit() {
      if (this.ajaxLoading) {
        return;
      }
      this.ajaxLoading = true;
      const hasSpouse = this.hasSpouse;
      const agidno = this.$store.state.userInfo.id;
      const familyid = this.headFamily.familyid
        ? this.headFamily.familyid
        : this.forms.filter((el) => el.relation == 0)[0].personalid;
      const newCustomer = this.forms.map((el) => {
        return {
          agidno: agidno,
          familyid: familyid,
          csidno: el.personalid || "",
          familyrl: el.relation,
          name: el.name,
          sex: el.sex,
          birthday: el.ROCbirthday
            ? window.moment(el.ROCbirthday).format("YYYY-MM-DD")
            : "",
          age: el.age,
          pdpa_agree_time: this.pdpaAgreeTime
        };
      });

      let idList = [];

      this.forms.forEach((item) => {
        const tmpID = item.personalid;
        if (tmpID) {
          idList.push(tmpID);
        }
      });

      let find_dup_list = idList.filter(
        (item, index) => idList.indexOf(item) != index
      );
      if (find_dup_list.length) {
        this.$toast.info({
          title: "輸入ID重複【" + find_dup_list.join("、") + "】",
        });
        this.ajaxLoading = false;
        return;
      }

      this.panelOpen("mvMaskOpen");
      insertCustInFamilyBnk(
        this.$store.state.userInfo.id,
        newCustomer,
        idList
      ).then((result) => {
        this.ajaxLoading = false;
        this.panelClose("mvMaskOpen");
        if (result.header && result.header.status == "201") {
          let message = "";
          result.body.ids_isCrt.forEach((itemCrt) => {
            const tmpId = itemCrt.ID;
            message = "此ID【" + tmpId + "】已重複，請改用「加入現有客戶」加入";
            this.$toast.info({
              title: message,
            });
          });
        } else if (result.header && result.header.status == "200") {
          // 新增成功
          this.$toast.info({ title: result.header.message });
          //若為新建家戶，則更新UserItems內容
          if (!this.headFamily.familyid) {
            this.updateUserItems(
              newCustomer.filter((el) => el.familyrl == 0)[0]
            );
          }
          this.goBack("bkRelation");
        } else {
          if (
            result.header.message.includes("ID :") &&
            result.header.message.includes("格式有誤")
          ) {
            this.$toast.info({
              title: result.header.message.split("Message:").pop(),
            });
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      });
    },

    //刪除該筆
    handleRemove(id) {
      this.forms.splice(id, 1);
    },
    // +再增加一筆
    handleAddData() {
      const plainData = {
        name: "",
        personalid: "",
        birthday: "",
        sex: "",
        relation: "",
        birthYear: "",
        birthMonth: "",
        birthDate: "",
        age: "",
        birthDateOpt: [],
      };
      this.forms.push(plainData);
      this.registerHanlink();
    },
    // 取得戶長資訊
    getHeadFamily() {
      const leader = this.familyResult.find((obj) => {
        return obj.familyrl === 0;
      });
      if (window._.isEmpty(leader)) {
        this.goBack("bkmv-allHolder");
        this.$toast.info({ title: "無戶長資訊" });
        return;
      }
      this.headFamily = leader;

      //中文太長顯示全名pop
      window.$("#user-name").popover({
        trigger: "focus",
        placement: "bottom",
      });
    },
    // 上一頁
    goBack(defaultPath) {
      let backTo = this.getHistory("bkmv-allHolder");
      this.$router.push({
        name: backTo ? backTo : defaultPath,
      });
    },
    updateDateWithFormIndex(data, index, ageField) {
      if (data.ROCbirthday) {
        computeAge(
          this.$store.state.userInfo.id,
          window.moment(data.ROCbirthday).format("YYYY-MM-DD")
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            data.age = result.body.age;
          } else {
            data.age = "計算錯誤";
          }
        });
        this.$refs.age[index].disabled = true;
        this.errors.remove(ageField);
      } else {
        this.$refs.age[index].disabled = false;
        data.age = "";
      }
    },
    doClean(type, form, field) {
      if (type === 1) {
        form.name = "";
      } else if (type === 2) {
        form.personalid = "";
      } else if (type === 3) {
        form.age = "";
      }

      this.errors.remove(field);
    },
    stringBytes(c, isSub, size) {
      //計算字元長度 (字串, 是否檢查, 檢查的長度)
      let n = c.length;
      let s;
      let len = 0;
      for (let i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
  },
};
</script>
<style lang="scss" scoped>
.c2f_top_section {
  padding: 20px 20px 0 20px;
}

.c2f_top_text {
  font-size: 18px;
  font-weight: 600;
  margin: 10px 0 20px 0;
}

.fixed_bottom {
  position: fixed;
  bottom: 0;
  max-width: 100%;
  padding: 23px;
  background-color: #f5f5f5;
  box-shadow: rgb(158, 158, 158) 1px 3px 17px 0px;
}

.card-number {
  border-right: 1px dotted #c2c4c7;
  padding-left: 0;
}
.card .form,
.card .add {
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 10px 20px;
  border: 1px solid #989ca2;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);

  .waring-block {
    .text {
      width: 47px;
      height: 18px;
      font-size: 13px;
      color: #323a45;
      line-height: 13px;
      position: relative;
      padding: 3px 0 0 12px;
    }

    .text.lg {
      flex: 1;
      width: auto;
      padding-right: 4px;
    }
    .text::before {
      position: absolute;
      content: "*";
      color: red;
      top: 6px;
      left: 6px;
    }
  }

  .delete-btn {
    position: absolute;
    right: 0;
    font-size: 14px;
    padding: 2px 8px;
  }

  .radio > input {
    top: 11px;
    left: -2px;
    z-index: 2;
  }
  .form-control-inline.short {
    width: 90px;
  }

  .form-control.is-invalid {
    background-image: url("../../../../public/assets/common/icon-close-red.svg");
    background-size: 20px 20px;
    background-position: center right 8px;
    background-repeat: no-repeat;
  }

  .waring-text {
    margin-top: 5px;
    font-size: 13px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #de4054;
  }

  .close {
    position: absolute;
    right: -12px;
    top: -12px;
    display: block;
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 22px;
    color: white;
    background: #5b616a;
    border: 2px solid #fff;
    border-radius: 12px;
    -webkit-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
    -ms-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
    -o-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  }

  &.add {
    p {
      margin-left: 10px;
    }
  }
}

.bgColor {
  background-color: #ffffff;
}

.clearPosition {
  position: absolute;
  right: 15px;
  top: 45px;
}

.editbtn {
  width: 120px;
  height: 40px;
  padding-bottom: 30px;
}

.btnfont {
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
}

.clearButton {
  position: relative;
  width: 18px;
  pointer-events: auto;
}

.pickerDiv {
  position: absolute;
  padding-right: 10px;
  width: 130px;
  height: 40px;
  font-size: 22px;
  color: #f58818;
  pointer-events: none;
}

.calendarDiv {
  padding: 0 10px 0 10px;
  height: 40px;
  font-size: 24px;
  color: #f58818;
  outline: none;
}

.icon-calendar:before {
  position: relative;
  margin: 0;
  pointer-events: none;
}

div /deep/ .vdp-datepicker input {
  width: 130px;
}
</style>
